import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import type { PortfolioAddItemId } from "web_myplann/Portfolio/Types/PortfolioAddItemTypes";

const ROUTES_BY_ITEM_ID: Partial<Record<PortfolioAddItemId, () => string>> = {
	auto: Routing.Portfolio.PortfolioAddCar.path,
	art: Routing.Portfolio.PortfolioAddArt.path,
	propertyItem: Routing.Portfolio.PortfolioAddRealEstate.path,
	buildingSavings: Routing.Portfolio.PortfolioAddBuildingSavings.path,
	crypto: Routing.Portfolio.PortfolioAddCryptocurrency.path,
	leasing: Routing.Portfolio.PortfolioAddLeasing.path,
	businessLoan: Routing.Portfolio.PortfolioAddBusinessLoans.path,
	commodity: Routing.Portfolio.PortfolioAddCommodities.path,
	bankProduct: Routing.Portfolio.PortfolioAddBankProduct.path,
	pension: Routing.Portfolio.PortfolioAddPension.path,
	investment: Routing.Portfolio.PortfolioAddInvestment.path,
	lifeInsurance: Routing.Portfolio.PortfolioAddLifeInsurance.path,
	service: Routing.Portfolio.PortfolioAddServices.path,
};

export const useNavigatePortfolioAddItem = () => {
	const navigate = useNavigate();

	return useCallback(
		(id: PortfolioAddItemId) => {
			const getPath = ROUTES_BY_ITEM_ID[id];
			if (getPath) {
				navigate(getPath());
			}
		},
		[navigate],
	);
};
